/** Stands in for network latency until the backend endpoints exist. */
export const mockDelay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Replaces the matching item rather than editing it: queries hand these objects to the store, which freezes them.
 * Returns false when nothing matched.
 */
export function replaceMockItem<T>(items: T[], matches: (item: T) => boolean, update: (item: T) => T): boolean {
  const index = items.findIndex(matches);
  if (index === -1) return false;

  items[index] = update(items[index]);
  return true;
}

/** "403" or "500" makes every project change fail with that status, so its error toasts can be tried out. */
const MOCK_PROJECT_ERROR_STORAGE_KEY = 'fletch:mock-project-error';

export const readMockProjectError = (): { status: number; data: string } | null => {
  try {
    const status = Number(localStorage.getItem(MOCK_PROJECT_ERROR_STORAGE_KEY));
    return status >= 400 ? { status, data: 'Mock project error' } : null;
  } catch {
    return null;
  }
};
